export default __webpack_public_path__ + "static/media/mml_umich_unt_merged_logos.70d5dfbe.png";